var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "6" } },
            [_c("admin-breadcrumb", { attrs: { name: "Category Images" } })],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "text-right align-self-end", attrs: { sm: "6" } },
            [
              _c(
                "b-btn",
                {
                  staticClass: "mb-4",
                  attrs: { variant: "success" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.newModal.open()
                    },
                  },
                },
                [_vm._v("Add new Image")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: {
                    title: "Category Images",
                    "sub-title": "Manage all category images in GreenLists",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header-right",
                      fn: function () {
                        return [
                          _c("b-form-select", {
                            staticClass: "w-auto mr-2 mt-2",
                            attrs: { options: _vm.categoryTypes },
                            model: {
                              value: _vm.filters.category_type,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "category_type", $$v)
                              },
                              expression: "filters.category_type",
                            },
                          }),
                          _vm._v(" "),
                          _c("b-form-select", {
                            staticClass: "w-auto mt-2",
                            attrs: {
                              options: _vm.categories,
                              disabled: !_vm.filters.category_type,
                            },
                            model: {
                              value: _vm.filters.category,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "category", $$v)
                              },
                              expression: "filters.category",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "admin-category-images mt-3" },
                    _vm._l(_vm.categoryImages, function (image, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "admin-category-image" },
                        [
                          _c("b-img-lazy", {
                            staticClass: "admin-category-image-img",
                            attrs: {
                              src: image.url,
                              alt: image.name,
                              thumbnail: "",
                              "fluid-grow": "",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "admin-category-image-delete",
                              attrs: {
                                title: "delete image",
                                variant: "danger",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.deleteCategoryImage(image)
                                },
                              },
                            },
                            [_vm._v("\n              Delete\n            ")]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("admin-category-image-add-modal", {
        ref: "newModal",
        on: { success: _vm.onCategoryImagesAdded },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }